// @flow
import React from "react";
import { observable } from "mobx";
import TextEditorContainer from "sulu-admin-bundle/containers/TextEditor";
import userStore from "sulu-admin-bundle/stores/userStore";

export default class TextEditorParagraphs extends React.Component {
  render() {
    const {
      disabled,
      formInspector,
      onChange,
      onFinish,
      schemaOptions,
      value,
    } = this.props;

    const locale = formInspector.locale
      ? formInspector.locale
      : observable.box(userStore.contentLocale);

    return (
      <TextEditorContainer
        adapter="ckeditor5_paragraphs"
        disabled={!!disabled}
        locale={locale}
        onBlur={onFinish}
        onChange={onChange}
        options={schemaOptions}
        value={value}
      />
    );
  }
}
